module.exports = __webpack_public_path__ + "media/images/help/flow/pill-3weeks-4a55fc5ed698afd153e331d286e977be.svg";